// Compact, reusable courier-escalation badge. Drop into any row/drawer.
// Clicking navigates to the Courier Escalations dashboard.
import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { slaStatus, STATUS_LABELS, isActiveStatus } from '../logic/courierEscalation';

const PRIORITY_RING = {
  critical: 'border-red-300 bg-red-50 text-red-700',
  high: 'border-orange-300 bg-orange-50 text-orange-700',
  medium: 'border-amber-300 bg-amber-50 text-amber-700',
  low: 'border-slate-300 bg-slate-50 text-slate-600',
};

// Navigate to /escalations (optionally focus one). Cross-module deep-link is by hash.
const goToEscalation = (id) => {
  try { window.location.hash = ''; } catch { /* noop */ }
  window.location.assign(`/escalations${id ? `#${id}` : ''}`);
};

export const EscalationBadge = ({ escalation, onClick, compact = false }) => {
  if (!escalation) return null;
  const sla = slaStatus(escalation);
  const active = isActiveStatus(escalation.status);
  const tone = PRIORITY_RING[escalation.priority] || PRIORITY_RING.low;
  const handle = (e) => { e.stopPropagation(); onClick ? onClick(escalation) : goToEscalation(escalation.id); };
  return (
    <button
      onClick={handle}
      title={`${escalation.reasonLabel || ''} · ${STATUS_LABELS[escalation.status] || escalation.status}`}
      className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-[10px] font-bold ${tone} ${active ? '' : 'opacity-60'}`}
    >
      <ShieldAlert size={11} />
      {escalation.escalationNumber}
      {!compact && <span className="font-medium">· {STATUS_LABELS[escalation.status] || escalation.status}</span>}
      {sla.breached && <span className="ml-0.5 rounded bg-red-600 px-1 text-white">SLA</span>}
    </button>
  );
};

// "Create / View Escalation" affordance — shows the active badge or a create button.
export const EscalationCell = ({ escalation, onCreate }) => {
  if (escalation) return <EscalationBadge escalation={escalation} />;
  if (!onCreate) return <span className="text-slate-300 text-xs">—</span>;
  return (
    <button onClick={(e) => { e.stopPropagation(); onCreate(); }} className="text-[10px] font-semibold text-teal-600 hover:underline">
      + Escalate
    </button>
  );
};

export default EscalationBadge;
